export const PHONE_REGEX = /(^0[0-9]{1,2})(-)?([0-9]{3,4})(-)?([0-9]{4})/;
export const EMAIL_REGEX = /[A-Za-z0-9+_.-]+@([A-Za-z0-9-_]+\.)+[A-Za-z]{2,4}/;
export const SOCIAL_SECURITY_NUMBER =
  /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))[1-4]$/;
export const NUMBER_REGEX = /^[0-9]*$/;